import "./Toolbar.css";
import "../theme/GlobalStyles.css";
import { IonButton } from "@ionic/react";
import appLogo from "../assets/images/Logo_Outline.png";
import settingsIcon from "../assets/images/Button_Settings.png";
import userIcon from "../assets/images/Button_Account.png";
import caretIcon from "../assets/images/Button_Caret_P83.png";
import chevronIcon from "../assets/images/Button_Chevron_Right.png";
import logoutIcon from "../assets/images/Button_Logout.png";
import { useContext, useState } from "react";
import AppContext from "../providers/AppContext";
import { APIService } from "../network/APIService";
import { RouteComponentProps } from "react-router";
import ChangePasswordModal from "./ChangePasswordModal";
import FAQsModal from "./FAQsModal";

const MenuButton = ({ text, icon, clickHandler }: { text: string; icon: string; clickHandler: () => void }) => {
  return (
    <IonButton onClick={clickHandler} className="toolbarMenuButton">
      <span className="toolbarMenuButtonInnerContainer">
        {text}
        <img src={icon} alt={text} width="44px" height="44px" />
      </span>
    </IonButton>
  );
};

const Toolbar = ({ props }: { props: RouteComponentProps }) => {
  const appContext = useContext(AppContext);

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showFAQsModal, setShowFAQsModal] = useState(false);

  let isAdmin = false;
  if (appContext.currentUser) {
    if (appContext.currentUser.groups.includes("Admin")) {
      isAdmin = true;
    }
  }

  return (
    <>
      <div id="toolbarContainer">
        <IonButton id="toolbarAppLogo" routerLink="/">
          <img src={appLogo} alt="Logo" width="88px" height="70px" />
        </IonButton>
        <div id="toolbarButtonsContainer">
          {/* settings dropdown */}
          {isAdmin && (
            <div id="settingsDropdown">
              <button className="toolbarButton">
                <img src={settingsIcon} alt="settings icon" width="44px" height="44px" />
                Settings
                <img src={caretIcon} alt="caret icon" width="44px" height="44px" />
              </button>
              <div id="settingsDropdownContent">
                <MenuButton
                  text="Users"
                  icon={chevronIcon}
                  clickHandler={() => props.history.push("/user-management")}
                />
                <MenuButton
                  text="Groups"
                  icon={chevronIcon}
                  clickHandler={() => props.history.push("/group-management")}
                />
              </div>
            </div>
          )}
          {/* user dropdown */}
          <div id="userDropdown">
            <button className="toolbarButton">
              <img src={userIcon} alt="user icon" width="44px" height="44px" />
              {appContext.currentUser ? appContext.currentUser.displayName : "Unknown"}
              <img src={caretIcon} alt="caret icon" width="44px" height="44px" />
            </button>
            <div id="userDropdownContent">
              {isAdmin && (
                <MenuButton
                  text="User Profile"
                  icon={chevronIcon}
                  clickHandler={() => {
                    appContext.setUserToEdit(appContext.currentUser!);
                    props.history.push("/edit-user");
                  }}
                />
              )}
              <MenuButton
                text="Change Password"
                icon={chevronIcon}
                clickHandler={() => setShowChangePasswordModal(true)}
              />
              <MenuButton text="Show FAQs" icon={chevronIcon} clickHandler={() => setShowFAQsModal(true)} />
              <MenuButton
                text="Sign Out"
                icon={logoutIcon}
                clickHandler={async () => {
                  // setSigningOut(true);
                  const signOutSuccess = await APIService.signOutUser();
                  if (!signOutSuccess) {
                    // TODO handle error signing out
                  }
                  // setSigningOut(false);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <ChangePasswordModal
        isOpen={showChangePasswordModal}
        handleModalDismiss={() => setShowChangePasswordModal(false)}
      />
      <FAQsModal isOpen={showFAQsModal} handleModalDismiss={() => setShowFAQsModal(false)} />
    </>
  );
};

export default Toolbar;
